import store from 'Store';

async function registerStoreModule(to, from, next) {
  const { default: storeModule } = await import(/* webpackChunkName: 'storeModuleResources' */ '../store');
  if (!store.hasModule('resources')) {
    store.registerModule('resources', storeModule);
  }
  next();
}

export default [
  {
    path: '/resources',
    name: 'resources',
    component: () => import(/* webpackChunkName: 'PageResources' */ '../PageResources'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['page/getPageData', 'resources/getResourceLearnMostPopularData'],
    },
  },
];
